import { ChannelStatus, ChannelType } from '@/models/channel.model';

export enum FaqChannelEndpoints {
  ROOT = '/faq-channels',
}

export const staticFaqChannelEndpoints = {
  GET_FAQ_CHANNELS: FaqChannelEndpoints.ROOT,
};

export interface IFaqChannel {
  channelId: number;
  slug: string;
  name: string;
  type: ChannelType | null;
  status: ChannelStatus | null;
  enabledForBot: boolean;
  siteUrl: string | null;
}

// ============== Response ==============

export interface IGetFaqChannelsResponse {
  channels: IFaqChannel[];
}
